<template>
  <div class="order-info">
    <BaseElForm label-width="150px" label-position="left">
      <BaseElFormItem label="餐廳代碼">
        <div>{{ foodpandaRestaurantInfo.code }}</div>
      </BaseElFormItem>
      <BaseElFormItem label="餐廳名稱">
        <div>{{ foodpandaRestaurantInfo.name }}</div>
      </BaseElFormItem>
      <BaseElFormItem label="聯絡人名稱">
        <div>{{ foodpandaRestaurantInfo.contactName }}</div>
      </BaseElFormItem>
      <BaseElFormItem label="聯絡人手機">
        <div>{{ foodpandaRestaurantInfo.contactMobile }}</div>
      </BaseElFormItem>
      <BaseElFormItem label="餐廳電話">
        <div>{{ foodpandaRestaurantInfo.phone }}</div>
      </BaseElFormItem>
      <BaseElFormItem label="餐廳地址">
        <div>{{ foodpandaRestaurantInfo.address }}</div>
      </BaseElFormItem>
    </BaseElForm>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'FoodpandaRestaurantBlock',
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  setup (props, { emit }) {
    const foodpandaRestaurantInfo = computed(() => {
      return props.order.AppointmentOrder.customInfo.foodpandaRestaurant
    })
    return {
      foodpandaRestaurantInfo,
    }
  },
}
</script>

<style scoped>
</style>
